import { render, staticRenderFns } from "./AtomVolverAlServidor.vue?vue&type=template&id=2279aa37"
import script from "./AtomVolverAlServidor.vue?vue&type=script&lang=js"
export * from "./AtomVolverAlServidor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports